import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useKnowledgeItemsByDimension = (dimensionId) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['knowledgeItems', dimensionId],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/knowledge-items/dimension/${dimensionId}` });
      return result;
    },
    enabled: !!dimensionId,
    staleTime: 5 * 60 * 1000
  });
};
